export default __webpack_public_path__ + "static/media/1794.bb24b044.png";